
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./Homepage.css";

// const Homepage = () => {
//   const solutions = [
//     {
//       id: 1,
//       title: 'Onsite Solar',
//       description: 'Make progress toward decarbonization and expedite the transition to clean energy with minimized risk and complexity—all without upfront capital expenditures.',
//       // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
//       image: require('./images/9.png'),
//       fallbackColor: '#447793',
//       link: '/solutions/onsite-solar',
//       color: '#447793'
//     },
//     {
//       id: 2,
//       title: 'Energy Storage',
//       description: 'Optimize and access reliable, cost-effective energy through advanced commercial and industrial energy storage solutions, safeguarding your facility from power outages and interruptions.',
//       // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
//       image: require('./images/8.png'),
//       fallbackColor: '#2D5A74',
//       link: '/solutions/energy-storage',
//       color: '#2D5A74'
//     },
//     {
//       id: 3,
//       title: 'EV Charging Solutions',
//       description: 'Comprehensive electric vehicle charging infrastructure for residential, commercial, and public spaces with smart management systems.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/7.png'),
//       fallbackColor: '#123249',
//       link: '/solutions/ev-charging',
//       color: '#123249'
//     },
//     {
//       id: 4,
//       title: 'Energy Monitoring',
//       description: 'Real-time energy monitoring and analytics to optimize consumption, reduce costs, and improve sustainability performance.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/6.png'),
//       fallbackColor: '#061221',
//       link: '/solutions/monitoring',
//       color: '#061221'
//     }
//   ];

//   const features = [
//     {
//       id: 1,
//       title: 'Expert Solar Installation',
//       description: 'Our certified technicians provide professional solar panel installation with precision and care. We ensure optimal positioning for maximum energy generation and long-term reliability.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential6.jpg'),
//       fallbackColor: '#447793',
//       align: 'left',
//       points: [
//         'Certified technicians',
//         'Optimal positioning',
//         'Quality materials',
//         'Quick installation'
//       ]
//     },
//     {
//       id: 2,
//       title: 'Energy Efficiency Solutions',
//       description: 'Comprehensive energy audits and efficiency solutions to reduce your carbon footprint and energy costs. We analyze your current consumption and provide tailored recommendations.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential5.jpg'),
//       fallbackColor: '#2D5A74',
//       align: 'right',
//       points: [
//         'Energy audits',
//         'Cost reduction',
//         'Tailored solutions',
//         'Sustainable practices'
//       ]
//     },
//     {
//       id: 3,
//       title: 'Maintenance & Support',
//       description: 'Ongoing maintenance and 24/7 support ensure your solar system operates at peak efficiency. Our dedicated team provides regular check-ups and immediate assistance.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential4.jpg'),
//       fallbackColor: '#123249',
//       align: 'left',
//       points: [
//         '24/7 support',
//         'Regular maintenance',
//         'Performance monitoring',
//         'Warranty coverage'
//       ]
//     }
//   ];
//   const [hovered, setHovered] = useState(false);
//   const [typedText, setTypedText] = useState("");
//   const [currentWordIndex, setCurrentWordIndex] = useState(0);
//   const [charIndex, setCharIndex] = useState(0);
//   const [isDeleting, setIsDeleting] = useState(false);

//   const words = ["Sustainable", "Clean", "Renewable", "Green"];
//   const currentWord = words[currentWordIndex];

//   useEffect(() => {
//     const typeSpeed = isDeleting ? 50 : 100;
//     const pauseTime = isDeleting ? 500 : 2000;

//     const timeout = setTimeout(() => {
//       if (!isDeleting && charIndex < currentWord.length) {
//         setTypedText(currentWord.substring(0, charIndex + 1));
//         setCharIndex(charIndex + 1);
//       } else if (isDeleting && charIndex > 0) {
//         setTypedText(currentWord.substring(0, charIndex - 1));
//         setCharIndex(charIndex - 1);
//       } else if (!isDeleting && charIndex === currentWord.length) {
//         setTimeout(() => setIsDeleting(true), pauseTime);
//       } else if (isDeleting && charIndex === 0) {
//         setIsDeleting(false);
//         setCurrentWordIndex((prev) => (prev + 1) % words.length);
//       }
//     }, typeSpeed);

//     return () => clearTimeout(timeout);
//   }, [charIndex, isDeleting, currentWord]);

//   return (
//     <div className="homepage">
//       {/* Hero Section */}
//       <section
//         className="hero-section"
//         onMouseEnter={() => setHovered(true)}
//         onMouseLeave={() => setHovered(false)}
//       >
//         {/* Background Image */}
//         <div className={`hero-bg-image ${hovered ? "zoomed" : ""}`}>
//           <img
//             src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
//             alt="Solar Panels"
//             className="bg-img"
//           />
//           <div className="bg-overlay"></div>
//         </div>

//         <div className="hero-content">
//           <h1 className={`hero-title ${hovered ? "color-changed" : ""}`}>
//             <span className="typing-text">
//               {typedText}
//               <span className="cursor">|</span>
//             </span>
//             <span className="static-text"> Energy Solutions</span>
//             <span className="hero-subtitle">for a Greener Tomorrow</span>
//           </h1>

//           <p className="hero-description">
//             Pioneering clean energy solutions that drive decarbonization while
//             ensuring economic viability and reliability.
//           </p>

//           <div className="hero-buttons">
//             <Link to="/contact" className="btn btn-primary">
//               <span className="btn-icon"></span>
//               <span className="btn-text">Get Started</span>
//               <span className="btn-hover-effect"></span>
//             </Link>

//             <Link to="/solutions" className="btn btn-secondary">
//               <span className="btn-icon"></span>
//               <span className="btn-text">Explore Solutions</span>
//               <span className="btn-hover-effect"></span>
//             </Link>
//           </div>

//           {/* Floating Elements */}
//           <div className="floating-elements">
//             <div className="float-icon solar-icon">☀️</div>
//             <div className="float-icon leaf-icon">🌿</div>
//             <div className="float-icon wind-icon">💨</div>
//             <div className="float-icon battery-icon">🔋</div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="scroll-indicator">
//           <div className="mouse">
//             <div className="wheel"></div>
//           </div>
//           <div className="arrow">
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//       </section>

//       {/* Rest of your existing code... */}
//       {/* Solutions Grid Section */}
//       {/* Features Section */}
//       <section className="solutions-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Modern Energy Solutions</h2>
//             <p className="section-subtitle">
//               Comprehensive energy solutions tailored to your needs
//             </p>
//           </div>

//           <div className="solutions-grid">
//             {solutions.map((solution) => (
//               <div key={solution.id} className="solution-card">
//                 <div
//                   className="solution-image"
//                   style={{
//                     backgroundImage: `url(${solution.image})`,
//                     backgroundColor: solution.fallbackColor,
//                   }}
//                 >
//                   <div
//                     className="solution-overlay"
//                     style={{ backgroundColor: `${solution.color}80` }}
//                   ></div>
//                   {/* <div className="fallback-icon">
//                     {solution.title === "Onsite Solar" && "☀️"}
//                     {solution.title === "Energy Storage" && "🔋"}
//                     {solution.title === "EV Charging Solutions" && "⚡"}
//                     {solution.title === "Energy Monitoring" && "📊"}
//                   </div> */}
//                 </div>
//                 <div className="solution-content">
//                   <h3 className="solution-title">{solution.title}</h3>
//                   <p className="solution-description">{solution.description}</p>
//                   <Link to={solution.link} className="solution-link">
//                     Learn More →
//                   </Link>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Section - Alternating Image & Text */}
//       <section className="features-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Why Choose Blue Sky Energy</h2>
//             <p className="section-subtitle">
//               Committed to excellence in every project we undertake
//             </p>
//           </div>

//           {features.map((feature) => (
//             <div key={feature.id} className={`feature-row ${feature.align}`}>
//               <div className="feature-content">
//                 <h3 className="feature-title">{feature.title}</h3>
//                 <p className="feature-description">{feature.description}</p>
//                 <ul className="feature-points">
//                   {feature.points.map((point, index) => (
//                     <li key={index} className="feature-point">
//                       <span className="point-icon">✓</span>
//                       {point}
//                     </li>
//                   ))}
//                 </ul>
//                 <Link to="/contact" className="btn btn-primary feature-btn">
//                   Get Started
//                 </Link>
//               </div>
//               <div className="feature-image">
//                 <div
//                   className="image-container"
//                   style={{
//                     backgroundImage: `url(${feature.image})`,
//                     backgroundColor: feature.fallbackColor,
//                   }}
//                 >
//                   <div className="image-overlay"></div>
//                   <div className="fallback-content">
//                     {/* <div className="fallback-icon-large">
//                       {feature.id === 1 && "🏗️"}
//                       {feature.id === 2 && "📊"}
//                       {feature.id === 3 && "🔧"}
//                     </div> */}
//                     <div className="fallback-text">{feature.title}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Homepage;



















// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./Homepage.css";

// const Homepage = () => {
//   const solutions = [
//     {
//       id: 1,
//       title: 'Onsite Solar',
//       description: 'Make progress toward decarbonization and expedite the transition to clean energy with minimized risk and complexity—all without upfront capital expenditures.',
//       // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
//       image: require('./images/9.png'),
//       fallbackColor: '#447793',
//       link: '/solutions/onsite-solar',
//       color: '#447793'
//     },
//     {
//       id: 2,
//       title: 'Energy Storage',
//       description: 'Optimize and access reliable, cost-effective energy through advanced commercial and industrial energy storage solutions, safeguarding your facility from power outages and interruptions.',
//       // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
//       image: require('./images/8.png'),
//       fallbackColor: '#2D5A74',
//       link: '/solutions/energy-storage',
//       color: '#2D5A74'
//     },
//     {
//       id: 3,
//       title: 'EV Charging Solutions',
//       description: 'Comprehensive electric vehicle charging infrastructure for residential, commercial, and public spaces with smart management systems.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/7.png'),
//       fallbackColor: '#123249',
//       link: '/solutions/ev-charging',
//       color: '#123249'
//     },
//     {
//       id: 4,
//       title: 'Energy Monitoring',
//       description: 'Real-time energy monitoring and analytics to optimize consumption, reduce costs, and improve sustainability performance.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/6.png'),
//       fallbackColor: '#061221',
//       link: '/solutions/monitoring',
//       color: '#061221'
//     }
//   ];

//   const features = [
//     {
//       id: 1,
//       title: 'Expert Solar Installation',
//       description: 'Our certified technicians provide professional solar panel installation with precision and care. We ensure optimal positioning for maximum energy generation and long-term reliability.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential6.jpg'),
//       fallbackColor: '#447793',
//       align: 'left',
//       points: [
//         'Certified technicians',
//         'Optimal positioning',
//         'Quality materials',
//         'Quick installation'
//       ]
//     },
//     {
//       id: 2,
//       title: 'Energy Efficiency Solutions',
//       description: 'Comprehensive energy audits and efficiency solutions to reduce your carbon footprint and energy costs. We analyze your current consumption and provide tailored recommendations.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential5.jpg'),
//       fallbackColor: '#2D5A74',
//       align: 'right',
//       points: [
//         'Energy audits',
//         'Cost reduction',
//         'Tailored solutions',
//         'Sustainable practices'
//       ]
//     },
//     {
//       id: 3,
//       title: 'Maintenance & Support',
//       description: 'Ongoing maintenance and 24/7 support ensure your solar system operates at peak efficiency. Our dedicated team provides regular check-ups and immediate assistance.',
//       // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
//       image: require('./images/residential4.jpg'),
//       fallbackColor: '#123249',
//       align: 'left',
//       points: [
//         '24/7 support',
//         'Regular maintenance',
//         'Performance monitoring',
//         'Warranty coverage'
//       ]
//     }
//   ];
//   const [hovered, setHovered] = useState(false);
//   const [typedText, setTypedText] = useState("");
//   const [currentWordIndex, setCurrentWordIndex] = useState(0);
//   const [charIndex, setCharIndex] = useState(0);
//   const [isDeleting, setIsDeleting] = useState(false);

//   const words = ["Sustainable", "Clean", "Renewable", "Green"];
//   const currentWord = words[currentWordIndex];

//   useEffect(() => {
//     const typeSpeed = isDeleting ? 50 : 100;
//     const pauseTime = isDeleting ? 500 : 2000;

//     const timeout = setTimeout(() => {
//       if (!isDeleting && charIndex < currentWord.length) {
//         setTypedText(currentWord.substring(0, charIndex + 1));
//         setCharIndex(charIndex + 1);
//       } else if (isDeleting && charIndex > 0) {
//         setTypedText(currentWord.substring(0, charIndex - 1));
//         setCharIndex(charIndex - 1);
//       } else if (!isDeleting && charIndex === currentWord.length) {
//         setTimeout(() => setIsDeleting(true), pauseTime);
//       } else if (isDeleting && charIndex === 0) {
//         setIsDeleting(false);
//         setCurrentWordIndex((prev) => (prev + 1) % words.length);
//       }
//     }, typeSpeed);

//     return () => clearTimeout(timeout);
//   }, [charIndex, isDeleting, currentWord]);

//   return (
//     <div className="homepage">
//       {/* Hero Section */}
//       <section
//         className="hero-section"
//         onMouseEnter={() => setHovered(true)}
//         onMouseLeave={() => setHovered(false)}
//       >
//         {/* Background Image */}
//         <div className={`hero-bg-image ${hovered ? "zoomed" : ""}`}>
//           <img
//             src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
//             alt="Solar Panels"
//             className="bg-img"
//           />
//           <div className="bg-overlay"></div>
//         </div>

//         <div className="hero-content">
//           <h1 className={`hero-title ${hovered ? "color-changed" : ""}`}>
//             <span className="typing-text">
//               {typedText}
//               <span className="cursor">|</span>
//             </span>
//             <span className="static-text"> Energy Solutions</span>
//             <span className="hero-subtitle">for a Greener Tomorrow</span>
//           </h1>

//           <p className="hero-description">
//             Pioneering clean energy solutions that drive decarbonization while
//             ensuring economic viability and reliability.
//           </p>

//           <div className="hero-buttons">
//             <Link to="/contact" className="btn btn-primary">
//               <span className="btn-icon"></span>
//               <span className="btn-text">Get Started</span>
//               <span className="btn-hover-effect"></span>
//             </Link>

//             <Link to="/solutions" className="btn btn-secondary">
//               <span className="btn-icon"></span>
//               <span className="btn-text">Explore Solutions</span>
//               <span className="btn-hover-effect"></span>
//             </Link>
//           </div>

//           {/* Floating Elements */}
//           <div className="floating-elements">
//             <div className="float-icon solar-icon">☀️</div>
//             <div className="float-icon leaf-icon">🌿</div>
//             <div className="float-icon wind-icon">💨</div>
//             <div className="float-icon battery-icon">🔋</div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <div className="scroll-indicator">
//           <div className="mouse">
//             <div className="wheel"></div>
//           </div>
//           <div className="arrow">
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//       </section>

//       {/* Solutions Grid Section */}
//       <section className="solutions-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Modern Energy Solutions</h2>
//             <p className="section-subtitle">
//               Comprehensive energy solutions tailored to your needs
//             </p>
//           </div>

//           <div className="solutions-grid">
//             {solutions.map((solution) => (
//               <div key={solution.id} className="solution-card">
//                 <div
//                   className="solution-image"
//                   style={{
//                     backgroundImage: `url(${solution.image})`,
//                     backgroundColor: solution.fallbackColor,
//                   }}
//                 >
//                   <div
//                     className="solution-overlay"
//                     style={{ backgroundColor: `${solution.color}80` }}
//                   ></div>
//                 </div>
//                 <div className="solution-content">
//                   <h3 className="solution-title">{solution.title}</h3>
//                   <p className="solution-description">{solution.description}</p>
//                   <Link to={solution.link} className="solution-link">
//                     Learn More →
//                   </Link>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Section - Alternating Image & Text */}
//       <section className="features-section">
//         <div className="container">
//           <div className="section-header">
//             <h2 className="section-title">Why Choose Blue Sky Energy</h2>
//             <p className="section-subtitle">
//               Committed to excellence in every project we undertake
//             </p>
//           </div>

//           {features.map((feature) => (
//             <div key={feature.id} className={`feature-row ${feature.align}`}>
//               <div className="feature-content">
//                 <h3 className="feature-title">{feature.title}</h3>
//                 <p className="feature-description">{feature.description}</p>
//                 <ul className="feature-points">
//                   {feature.points.map((point, index) => (
//                     <li key={index} className="feature-point">
//                       <span className="point-icon">✓</span>
//                       {point}
//                     </li>
//                   ))}
//                 </ul>
//                 <Link to="/contact" className="btn btn-primary feature-btn">
//                   Get Started
//                 </Link>
//               </div>
//               <div className="feature-image">
//                 <div
//                   className="image-container"
//                   style={{
//                     backgroundImage: `url(${feature.image})`,
//                     backgroundColor: feature.fallbackColor,
//                   }}
//                 >
//                   <div className="image-overlay"></div>
//                   <div className="fallback-content">
//                     <div className="fallback-text">{feature.title}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Homepage;



















import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Homepage.css";

const Homepage = () => {
  const solutions = [
    {
      id: 1,
      title: 'Onsite Solar',
      description: 'Make progress toward decarbonization and expedite the transition to clean energy with minimized risk and complexity—all without upfront capital expenditures.',
      // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
      image: require('./images/9.png'),
      fallbackColor: '#447793',
      link: '/solutions/onsite-solar',
      color: '#447793'
    },
    {
      id: 2,
      title: 'Energy Storage',
      description: 'Optimize and access reliable, cost-effective energy through advanced commercial and industrial energy storage solutions, safeguarding your facility from power outages and interruptions.',
      // image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=800&h=400&fit=crop',
      image: require('./images/8.png'),
      fallbackColor: '#2D5A74',
      link: '/solutions/energy-storage',
      color: '#2D5A74'
    },
    {
      id: 3,
      title: 'EV Charging Solutions',
      description: 'Comprehensive electric vehicle charging infrastructure for residential, commercial, and public spaces with smart management systems.',
      // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
      image: require('./images/7.png'),
      fallbackColor: '#123249',
      link: '/solutions/ev-charging',
      color: '#123249'
    },
    {
      id: 4,
      title: 'Energy Monitoring',
      description: 'Real-time energy monitoring and analytics to optimize consumption, reduce costs, and improve sustainability performance.',
      // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
      image: require('./images/6.png'),
      fallbackColor: '#061221',
      link: '/solutions/monitoring',
      color: '#061221'
    }
  ];

  const features = [
    {
      id: 1,
      title: 'Expert Solar Installation',
      description: 'Our certified technicians provide professional solar panel installation with precision and care. We ensure optimal positioning for maximum energy generation and long-term reliability.',
      // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
      image: require('./images/residential6.jpg'),
      fallbackColor: '#447793',
      align: 'left',
      points: [
        'Certified technicians',
        'Optimal positioning',
        'Quality materials',
        'Quick installation'
      ]
    },
    {
      id: 2,
      title: 'Energy Efficiency Solutions',
      description: 'Comprehensive energy audits and efficiency solutions to reduce your carbon footprint and energy costs. We analyze your current consumption and provide tailored recommendations.',
      // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
      image: require('./images/residential5.jpg'),
      fallbackColor: '#2D5A74',
      align: 'right',
      points: [
        'Energy audits',
        'Cost reduction',
        'Tailored solutions',
        'Sustainable practices'
      ]
    },
    {
      id: 3,
      title: 'Maintenance & Support',
      description: 'Ongoing maintenance and 24/7 support ensure your solar system operates at peak efficiency. Our dedicated team provides regular check-ups and immediate assistance.',
      // image: 'https://images.unsplash.com/photo-1624397640148-949b1732bb0a?w-800&h=500&fit=crop',
      image: require('./images/residential4.jpg'),
      fallbackColor: '#123249',
      align: 'left',
      points: [
        '24/7 support',
        'Regular maintenance',
        'Performance monitoring',
        'Warranty coverage'
      ]
    }
  ];
  const [hovered, setHovered] = useState(false);
  const [typedText, setTypedText] = useState("");
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const words = ["Sustainable", "Clean", "Renewable", "Green"];
  const currentWord = words[currentWordIndex];

  useEffect(() => {
    const typeSpeed = isDeleting ? 50 : 100;
    const pauseTime = isDeleting ? 500 : 2000;

    const timeout = setTimeout(() => {
      if (!isDeleting && charIndex < currentWord.length) {
        setTypedText(currentWord.substring(0, charIndex + 1));
        setCharIndex(charIndex + 1);
      } else if (isDeleting && charIndex > 0) {
        setTypedText(currentWord.substring(0, charIndex - 1));
        setCharIndex(charIndex - 1);
      } else if (!isDeleting && charIndex === currentWord.length) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && charIndex === 0) {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }, typeSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, currentWord]);

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section
        className="hero-section"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Background Image */}
        <div className={`hero-bg-image ${hovered ? "zoomed" : ""}`}>
          <img
            src="https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
            alt="Solar Panels"
            className="bg-img"
          />
          <div className="bg-overlay"></div>
        </div>

        <div className="hero-content">
          <h1 className={`hero-title ${hovered ? "color-changed" : ""}`}>
            <span className="typing-text">
              {typedText}
              <span className="cursor">|</span>
            </span>
            <span className="static-text"> Energy Solutions</span>
            <span className="hero-subtitle">for a Greener Tomorrow</span>
          </h1>

          <p className="hero-description">
            Pioneering clean energy solutions that drive decarbonization while
            ensuring economic viability and reliability.
          </p>

          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">
              <span className="btn-icon"></span>
              <span className="btn-text">Get Started</span>
              <span className="btn-hover-effect"></span>
            </Link>

            <Link to="/solutions" className="btn btn-secondary">
              <span className="btn-icon"></span>
              <span className="btn-text">Explore Solutions</span>
              <span className="btn-hover-effect"></span>
            </Link>
          </div>

          {/* Floating Elements */}
          <div className="floating-elements">
            <div className="float-icon solar-icon">☀️</div>
            <div className="float-icon leaf-icon">🌿</div>
            <div className="float-icon wind-icon">💨</div>
            <div className="float-icon battery-icon">🔋</div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
          <div className="arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      {/* Solutions Grid Section */}
      <section className="solutions-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Modern Energy Solutions</h2>
            <p className="section-subtitle">
              Comprehensive energy solutions tailored to your needs
            </p>
          </div>

          <div className="solutions-grid">
            {solutions.map((solution) => (
              <div key={solution.id} className="solution-card">
                <div
                  className="solution-image"
                  style={{
                    backgroundImage: `url(${solution.image})`,
                    backgroundColor: solution.fallbackColor,
                  }}
                >
                  <div
                    className="solution-overlay"
                    style={{ backgroundColor: `${solution.color}80` }}
                  ></div>
                </div>
                <div className="solution-content">
                  <h3 className="solution-title">{solution.title}</h3>
                  <p className="solution-description">{solution.description}</p>
                  <Link to={solution.link} className="solution-link">
                    Learn More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section - Alternating Image & Text */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose Blue Sky Energy</h2>
            <p className="section-subtitle">
              Committed to excellence in every project we undertake
            </p>
          </div>

          {features.map((feature) => (
            <div key={feature.id} className={`feature-row ${feature.align}`}>
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
                <ul className="feature-points">
                  {feature.points.map((point, index) => (
                    <li key={index} className="feature-point">
                      <span className="point-icon">✓</span>
                      {point}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn btn-primary feature-btn">
                  Get Started
                </Link>
              </div>
              <div className="feature-image">
                <div
                  className="image-container"
                  style={{
                    backgroundImage: `url(${feature.image})`,
                    backgroundColor: feature.fallbackColor,
                  }}
                >
                  <div className="image-overlay"></div>
                  <div className="fallback-content">
                    <div className="fallback-text">{feature.title}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Homepage;